var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.78125 1.375C0.78125 1.04708 1.04708 0.78125 1.375 0.78125H12.6562C12.8137 0.78125 12.9647 0.843806 13.0761 0.955155L16.0448 3.92391C16.1562 4.03525 16.2188 4.18628 16.2188 4.34375V15.625C16.2188 15.9529 15.9529 16.2188 15.625 16.2188H1.375C1.04708 16.2188 0.78125 15.9529 0.78125 15.625V1.375ZM4.9375 15.0312H12.0625V9.6875H4.9375V15.0312ZM13.25 15.0312V9.09375C13.25 8.76583 12.9842 8.5 12.6562 8.5H4.34375C4.01583 8.5 3.75 8.76583 3.75 9.09375V15.0312H1.96875V1.96875H3.75V4.9375C3.75 5.91854 4.55021 6.71875 5.53125 6.71875H10.2812C11.2623 6.71875 12.0625 5.91854 12.0625 4.9375V1.96875H12.4103L15.0312 4.58969V15.0312H13.25ZM10.875 1.96875H4.9375V4.9375C4.9375 5.26271 5.20604 5.53125 5.53125 5.53125H10.2812C10.6065 5.53125 10.875 5.26271 10.875 4.9375V1.96875ZM9.6875 2.5625C10.0154 2.5625 10.2812 2.82833 10.2812 3.15625V4.34375C10.2812 4.67167 10.0154 4.9375 9.6875 4.9375C9.35958 4.9375 9.09375 4.67167 9.09375 4.34375V3.15625C9.09375 2.82833 9.35958 2.5625 9.6875 2.5625Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.31173850ea1fa58dd6f80e5474aa5f34.svg";
export { ForwardRef as ReactComponent };